import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo?: Echo<'reverb'>;
  }
}

window.Pusher = Pusher;

function reverbEnabled(): boolean {
  return Boolean(import.meta.env.VITE_REVERB_APP_KEY);
}

export function getEcho(token: string | null): Echo<'reverb'> | null {
  if (!token || !reverbEnabled()) return null;

  if (window.Echo) {
    return window.Echo;
  }

  const apiBase = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/api';
  const scheme = import.meta.env.VITE_REVERB_SCHEME ?? 'http';
  const host = import.meta.env.VITE_REVERB_HOST ?? 'localhost';
  const port = Number(import.meta.env.VITE_REVERB_PORT ?? 8080);

  window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === 'https',
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${apiBase}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  });

  return window.Echo;
}

export function disconnectEcho(): void {
  window.Echo?.disconnect();
  window.Echo = undefined;
}

export { reverbEnabled };
